import ReservationUrlRepository from "../../../domain/reservation/url/ReservationUrlRepository";
import { ApiClient }            from "../../configure/ApiClientConfig";

class ReservationUrlDataSource implements ReservationUrlRepository {
  findBy() {
    return ApiClient.get("/reservation/setting/url");
  }
}

export default ReservationUrlDataSource;
